<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Clientes</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Clientes</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-agregar-cliente" class="info-box mb-3" @click="nuevoCliente" data-toggle="modal"
            data-target="#clienteModal">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-info elevation-1"><i
                class="fas fa-plus"></i></a>
            <div class="info-box-content">
              <span class="info-box-text">Cliente</span>
              <span class="info-box-number">Agregar</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-descargar-pdf" class="info-box mb-3" @click="descargarPDF()" style="cursor: pointer;">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-danger elevation-1">
              <i class="fas fa-file-pdf"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Descargar PDF</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Lista de clientes frecuentes</h3>
            </div>
            <div class="card-body">
              <table id="tablaClientes" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th style="width: 1%;">Código</th>
                    <th style="width: 10%;">RIF / C.I</th>
                    <th>Negocio</th>
                    <th>Dirección</th>
                    <th style="width: 11%;">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cliente, index) in clientes" :key="cliente.id">
                    <td>{{ cliente.codigo }}</td>
                    <td>{{ cliente.rif }}</td>
                    <td>
                      <a href="javascript:void(0)" @click="irAlHistorial(cliente.id)"
                        class="text-navy font-weight-bold">
                        <i class="fas fa-search-plus mr-1 small"></i> {{ cliente.nombre }}
                      </a>
                    </td>
                    <td>{{ cliente.direccion }}</td>
                    <td>
                      <div class="btn-group">

                        <button class="btn btn-info btn-historial" :data-id="cliente.id" title="Ver Expediente">
                          <i class="fas fa-folder-open"></i>
                        </button>

                        <button class="btn btn-warning btn-ver-mas" :data-index="index" data-toggle="modal"
                          data-target="#clienteModal">
                          Ver más
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cliente-modal v-if="modalActivo" :cliente="clienteSeleccionado" @actualizar="obtenerClientes"
      @cerrar="cerrarModal" />
  </section>
</template>

<script>
import { nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import ClienteModal from "./ClienteModal.vue";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';
import { tutorial } from "@/plugins/tutorial";

export default {
  name: "Clientes",
  components: { ClienteModal },

  data() {
    return {
      dt: null,                 // ← tabla instance
      clientes: [],             // datos
      clienteSeleccionado: null,
      modalActivo: false
    };
  },

  setup() {
    const { proxy } = getCurrentInstance();
    return { proxy };
  },

  methods: {
    irAlHistorial(id) {
      this.$router.push({ name: 'historial', params: { id } });
    },
    async obtenerClientes() {
      try {
        const { data } = await api.get("/clientes");
        this.clientes = data;

        // Esperamos que Vue pinte el <tbody>
        await nextTick();

        // Solo inicializamos DataTable la primera vez
        if (!this.dt && window.$ && $.fn.DataTable) {
          this.dt = $("#tablaClientes").DataTable({
            responsive: {
              details: { type: "column", target: "td.control" }
            },
            autoWidth: false,
            columnDefs: [
              // Indicamos la columna control
              { className: "control", orderable: false, targets: 0 },

              // Damos mayor prioridad a Código y Ver más
              { responsivePriority: 1, targets: 1 },  // Código
              { responsivePriority: -1, targets: 2 },
              { responsivePriority: -1, targets: 4 }
            ],

            pageLength: 10,
            lengthChange: false,
            pagingType: "numbers",
            language: {
              url:
                "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json"
            },
            // Estructura de DOM con filtro, tabla, info y paginación centrados
            dom:
              '<"row mb-3"<"col-12 col-md-6"f>>' +
              "t" +
              '<"row mt-3"<"col-12 text-center"i>>' +
              '<"row"<"col-12 d-flex justify-content-center"p>>'

          });
        }
        // Escuchar clicks en el botón Historial
        $("#tablaClientes").on("click", ".btn-historial", (e) => {
          const id = $(e.currentTarget).data("id");
          this.irAlHistorial(id);
        });

        // Escuchar clicks en el botón Ver más
        $("#tablaClientes").on("click", ".btn-ver-mas", (e) => {
          const index = $(e.currentTarget).data("index");
          this.mostrarCliente(this.clientes[index]);
        });
      } catch (error) {
        console.error("Error al obtener los clientes:", error);
      }
    },

    async descargarPDF() {
      try {
        loading.show('Generando PDF...');
        const response = await api.get("/pdf/clientes", { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Reporte_Clientes.pdf');
        document.body.appendChild(link);
        link.click();
        loading.hide();
      } catch (error) {
        loading.hide();
        alert.show({ title: 'Error', text: 'No se pudo generar el PDF', icon: 'error' });
      }
    },

    nuevoCliente() {
      this.clienteSeleccionado = {
        id: null,
        rif: "",
        nombre: "",
        encargado: "",
        telefono: "",
        email: "",
        tipo_contribuyente: "",
        direccion: ""
      };
      this.modalActivo = true;
    },

    mostrarCliente(cliente) {
      this.clienteSeleccionado = cliente;
      this.modalActivo = true;
    },

    cerrarModal() {
      this.modalActivo = false;
    },

    iniciarTutorial() {
      const steps = [
        {
          element: '#btn-agregar-cliente',
          title: 'Nuevo Cliente',
          text: 'Haz clic aquí para registrar un nuevo cliente.',
          position: 'bottom'
        },
        {
          element: '#btn-descargar-pdf',
          title: 'Descargar Reporte',
          text: 'Haz clic aquí para generar un PDF con el listado de clientes.',
          position: 'bottom'
        },
        {
          element: '.btn-info',
          title: 'Expediente del Cliente',
          text: 'Haz clic aquí para ver el historial detallado de ventas (contado/crédito) y pagos.',
          position: 'left'
        },
        {
          element: '.card-body',
          title: 'Listado de Clientes',
          text: 'Aquí verás la lista de clientes registrados.',
          position: 'top'
        }
      ];

      const table = window.$('#tablaClientes');
      const isCollapsed = table.hasClass('collapsed');
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');
        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        steps.push({
          element: '#tablaClientes tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en el símbolo (+) para ver los datos ocultos y las opciones.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function () {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;
            if (window.$(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn');
            } else {
              tooltip.classList.add('hide-next-btn');
            }
          }, 200);
        });

        steps.push({
          element: '.dtr-details .btn-warning',
          title: 'Ver más',
          text: 'Haz clic aquí para ver la información completa o editar el cliente.',
          position: 'left'
        });
      } else {
        steps.push({
          element: '.btn-warning',
          title: 'Ver más',
          text: 'Haz clic aquí para ver la información completa o editar el cliente.',
          position: 'left'
        });
      }

      tutorial.start(steps);
    }
  },

  mounted() {
    this.obtenerClientes();
    tutorial.set(this.iniciarTutorial);
  },

  beforeUnmount() {
    if (this.dt) {
      this.dt.destroy();
      this.dt = null;
    }
    tutorial.set(null);
  }
};
</script>

<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>